import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { LiaSpinnerSolid } from "react-icons/lia";

import blueKbcLogo from '../../../assets/images/branding/blue-kbc-logo.png';

import { FaRegFolder } from "react-icons/fa6";
import { BsFileEarmarkPdf } from "react-icons/bs";

// --------------------- CSS File --------------------
import '../../../assets/css/ShePack.css';
import { IoIosCloudDone } from 'react-icons/io';
import { MdCancel } from 'react-icons/md';
import { TiTick } from 'react-icons/ti';
import { ImCross } from 'react-icons/im';
import { RxCrossCircled } from 'react-icons/rx';

import { AiOutlineFileDone } from 'react-icons/ai';

const ToasterViewTemplateComplianceSubmissions = ({ 

  isOpen, 
  onClose,
  
  selectedSubmissionId,

  selectedSheFileId,
  selectedSheFileName,
  selectedSheFileUserScore,
  selectedSheFileScore,
  templates,
  isLoading,
  selectedCompany,
  selectedCompanyName,
  selectedDepartmentName,
  selectedDepartment, 

  // Functions 
  onRefreshTemplates // Brings latest scores after any changes done.
}) => {

  const navigate = useNavigate();

  // Filter templates
  const regularTemplates = templates.filter(template => 
    !(template.submission_type === 'Manual' && template.template_reference === "Medical Certificate")
  );

  const manualTemplates = templates.filter(template => 
    template.submission_type === 'Manual' && template.template_reference === "Medical Certificate"
  );

  // ----------------- State Management -----------------

  // State Management - Toasters
  const [showApproveToaster, setShowApproveToaster] = useState(false);
  const [showRejectToaster, setShowRejectToaster] = useState(false);
  const [selectedDocumentForQA, setSelectedDocumentForQA] = useState(null); 

  // State Management Employee - Toasters
  const [selectedEmployeeForQA, setSelectedEmployeeForQA] = useState(null);
  const [showEmployeeApproveToaster, setShowEmployeeApproveToaster] = useState(false);
  const [showEmployeeRejectToaster, setShowEmployeeRejectToaster] = useState(false);


  const [showToaster, setShowToaster] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  // Template document state
  const [templateDocuments, setTemplateDocuments] = useState({});
  const [loadingTemplateDocument, setLoadingTemplateDocument] = useState(false);
  const [viewingTemplateDocument, setViewingTemplateDocument] = useState(null);

  // Employee document state
  const [viewingEmployeeDocument, setViewingEmployeeDocument] = useState(null);
  const [loadingEmployeeDocument, setLoadingEmployeeDocument] = useState(false);
  const [employeeDocuments, setEmployeeDocuments] = useState({});

  // Employee data state
  const [employees, setEmployees] = useState({});
  const [loadingEmployees, setLoadingEmployees] = useState(false);

  const user = JSON.parse(sessionStorage.getItem('user'));

  /*-----------------------------------------------------------------
                            Use Effects 
  ---------------------------------------------------------------*/

  useEffect(() => {
    const timers = Object.keys(showToaster).map(key => 
      showToaster[key] && setTimeout(() => setShowToaster(prev => ({ ...prev, [key]: false })), 3000)
    );
    return () => timers.forEach(timer => clearTimeout(timer));
  }, [showToaster]);

  // Fetch employees for manual templates when component mounts
  useEffect(() => {
    if (manualTemplates.length > 0) {
      manualTemplates.forEach(template => {
        fetchEmployeesForTemplate(template);
      });
    }
  }, [templates, selectedCompany, selectedDepartment]);

  /*----------------------------------------------------
                      Functions
  ------------------------------------------------------*/

  // ------------------ Functions Approve and Reject Toasters -  -----------------

  const handleApproveClick = (document) => {
    setSelectedDocumentForQA(document);
    setShowApproveToaster(true);
  };

  const handleRejectClick = (document) => {
      setSelectedDocumentForQA(document);
      setShowRejectToaster(true);
  };

  const handleApproveClose = () => {
    setShowApproveToaster(false);
    setSelectedDocumentForQA(null);
  };

  const handleRejectClose = () => {
    setShowRejectToaster(false);
    setSelectedDocumentForQA(null);
  };

  // Employee Approve and Reject Click Handlers
  const handleEmployeeApproveClick = (employee, templateId) => {
  setSelectedEmployeeForQA({ ...employee, templateId });
  setShowEmployeeApproveToaster(true);
};

const handleEmployeeRejectClick = (employee, templateId) => {
  setSelectedEmployeeForQA({ ...employee, templateId });
  setShowEmployeeRejectToaster(true);
};



  
/*---------------------- Functions Approve and Reject - Save and Reject -----------------------*/




/*-------------------------------------------------------------------------*/
  const fetchEmployeesForTemplate = async (template) => {
    try {
      setLoadingEmployees(true);
      
      const encodedTemplateReference = encodeURIComponent(template.template_reference);
      
      const response = await axios.get(
        `/api/compliance-tracker/consultant-fill-in/manual-employee-upload/${selectedCompany}/${selectedDepartment}/${encodedTemplateReference}?templateId=${template.template_id}`
      );
      
      const employeesData = response.data || [];
      
      // Store employees data with template ID as key
      setEmployees(prev => ({
        ...prev,
        [template.template_id]: employeesData
      }));
      
      setLoadingEmployees(false);
      
    } catch (error) {
      console.error('Error fetching employees:', error);
      setErrorMessage('Failed to load employees. Please try again.');
      setLoadingEmployees(false);
      
      // Set empty array for this template on error
      setEmployees(prev => ({
        ...prev,
        [template.template_id]: []
      }));
    }
  };

  // Image preview handling
  const openFullScreenImage = (imageUrl) => {
    setFullScreenImage(imageUrl);
  };

  const closeFullScreenImage = () => {
    setFullScreenImage(null);
  };

  if (!isOpen) return null;

  // ----------------- Template Document Functions ----------------
  const handleViewTemplateDocument = async (templateId) => {
    try {
      setLoadingTemplateDocument(true);
      setFullScreenImage(null);
      
      // Check if we already have the document cached
      if (templateDocuments[templateId]) {
        setViewingTemplateDocument(templateDocuments[templateId]);
        setLoadingTemplateDocument(false);
        return;
      }
      
      // Fetch the document from API
      const response = await axios.get(
        `/api/compliance-tracker/file-and-template-viewer/view-template/${templateId}`
      );
      
      console.log("API Response:", response.data);
      
      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        const documentData = response.data[0];
        console.log("Document data:", documentData);
        
        setTemplateDocuments(prev => ({
          ...prev,
          [templateId]: documentData
        }));
        setViewingTemplateDocument(documentData);
      } else {
        setErrorMessage("No document found for this template.");
        setTimeout(() => setErrorMessage(''), 3000);
      }
      setLoadingTemplateDocument(false);
    } catch (error) {
      console.error('Error fetching template document:', error);
      setErrorMessage('Failed to load template document. Please try again.');
      setLoadingTemplateDocument(false);
    }
  };

  const closeTemplateDocumentViewer = () => {
    setViewingTemplateDocument(null);
    setFullScreenImage(null);
  };

  // ----------------- Employee Document Functions ----------------
  const fetchEmployeeDocument = async (employeeId, templateId) => {
    try {
      setLoadingEmployeeDocument(true);
      const compositeKey = `${templateId}-${employeeId}`;
      
      // Check if we already have the document cached
      if (employeeDocuments[compositeKey]) {
        setViewingEmployeeDocument(employeeDocuments[compositeKey]);
        setLoadingEmployeeDocument(false);
        return;
      }
      
      // Fetch the document from API
      const response = await axios.get(
        `/api/compliance-tracker/file-and-template-viewer/view-template/employee-documents/${employeeId}/${templateId}`
      );
      
      if (response.data && response.data.file_response) {
        setEmployeeDocuments(prev => ({
          ...prev,
          [compositeKey]: response.data
        }));
        setViewingEmployeeDocument(response.data);
      } else {
        setErrorMessage("No document found for this employee.");
        setTimeout(() => setErrorMessage(''), 3000);
      }
      setLoadingEmployeeDocument(false);
    } catch (error) {
      console.error('Error fetching employee document:', error);
      setErrorMessage('Failed to load employee document. Please try again.');
      setLoadingEmployeeDocument(false);
    }
  };

  const handleViewEmployeeDocument = (employee, templateId) => {
    setFullScreenImage(null);
    fetchEmployeeDocument(employee.employee_id, templateId);
  };
  
  const closeEmployeeDocumentViewer = () => {
    setViewingEmployeeDocument(null);
    setFullScreenImage(null);
  };

  /*----------------------------------------------------------
                        Document Rendering 
  ------------------------------------------------------------*/
  const bufferToBase64 = (buffer) => {
    if (buffer && buffer.type === 'Buffer' && Array.isArray(buffer.data)) {
      const binaryString = buffer.data.map(byte => String.fromCharCode(byte)).join('');
      return btoa(binaryString);
    }
    return null;
  };
    
  const renderTemplateDocument = (document) => {
    // Check if file_name exists, if not, return Not Applicable
    if (!document.file_name) {
      return <p>Not Applicable</p>;
    }

    // Check if the file is a PDF
    const isPdf = document.file_name.toLowerCase().endsWith('.pdf');
    
    if (isPdf) {
      const base64String = bufferToBase64(document.file_response);
      if (!base64String) {
        return <p>Invalid PDF data</p>;
      }

      const base64ToBinary = atob(base64String);
      
      return (
        <div className="pdf-container">
          <BsFileEarmarkPdf
            className='view-checklist-view-image-icon'
            onClick={() => {
              // Create a new window
              const pdfWindow = window.open('', '_blank');
              
              // Write the PDF content directly to the new window
              pdfWindow.document.write(
                `<html>
                  <head>
                    <title>${document.file_name}</title>
                  </head>
                  <body style="margin: 0;">
                    <iframe
                       src="data:application/pdf;base64,${base64ToBinary}"
                       width="100%"
                       height="100%"
                       style="border: none;"
                    ></iframe>
                  </body>
                </html>`
              );
              pdfWindow.document.close();
            }}
            style={{ cursor: 'pointer' }}
          />
          Click to View PDF Document
        </div>
      );
    }

    // For non-PDF files (images)
    const fileResponse = document.file_response;
    const base64String = bufferToBase64(fileResponse);
    
    if (!base64String) {
      console.log("Failed to convert buffer to base64");
      return <p>Could not process file</p>;
    }

    try {
      const base64ToBinary = atob(base64String);
      const mimeType = 'image/png';
    
      return (
        <div>
          <img 
            src={`data:${mimeType};base64,${base64ToBinary}`}
            alt="Document Preview"
            className="document-thumbnail"
            onClick={() => openFullScreenImage(`data:${mimeType};base64,${base64ToBinary}`)} 
          />
        </div>
      );
    } catch (error) {
      console.error("Error processing file:", error);
      return <p>Error displaying file</p>;
    }
  };

  const renderEmployeeDocument = (document) => {
    // Check if document exists and has file_response
    if (!document || !document.file_response) {
      return <p>No file available</p>;
    }

    // Check if file_name exists for PDF detection
    if (!document.file_name) {
      return <p>File name not available</p>;
    }

    // Check if the file is a PDF
    const isPdf = document.file_name.toLowerCase().endsWith('.pdf');
    
    if (isPdf) {
      const base64String = bufferToBase64(document.file_response);
      if (!base64String) {
        return <p>Invalid PDF data</p>;
      }

      const base64ToBinary = atob(base64String);
          
      return (
        <div className="pdf-container">
          <BsFileEarmarkPdf 
            className='view-checklist-view-image-icon'
            onClick={() => {
              // Create a new window
              const pdfWindow = window.open('', '_blank');
                          
              // Write the PDF content directly to the new window
              pdfWindow.document.write(
                `<html>
                  <head>
                    <title>${document.file_name}</title>
                  </head>
                  <body style="margin: 0;">
                    <iframe
                       src="data:application/pdf;base64,${base64ToBinary}"
                       width="100%"
                       height="100%"
                       style="border: none;"
                    ></iframe>
                  </body>
                </html>`
              );
              pdfWindow.document.close();
            }}
            style={{ cursor: 'pointer' }}
          />
          Click to View PDF Document
        </div>
      );
    }

    // For non-PDF files (images)
    const fileResponse = document.file_response;
    const base64String = bufferToBase64(fileResponse);
    
    if (!base64String) {
      console.log("Failed to convert buffer to base64");
      return <p>Could not process file</p>;
    }

    try {
      const base64ToBinary = atob(base64String);
      const mimeType = 'image/png';
    
      return (
        <div>
          <img 
            src={`data:${mimeType};base64,${base64ToBinary}`}
            alt="Document Preview"
            className="document-thumbnail"
            onClick={() => openFullScreenImage(`data:${mimeType};base64,${base64ToBinary}`)} 
          />
        </div>
      );
    } catch (error) {
      console.error("Error processing file:", error);
      return <p>Error displaying file</p>;
    }
  };

  return (
    <div className="checklist-question-user-fill-in-checklist-main-container">
      <div className="template-question-fill-in-checklist-container">
        <div className="template-fill-in-elements-container">
          <div className="user-fill-in-back-button-time-container">
            <div className='user-fill-in-back-button-container'>
              <img src={blueKbcLogo} alt="white-kbc-logo" className="add-quesiton-side-menu-logo" />
              <button type="button" onClick={onClose} className="user-fill-in-back-button"> Back</button>
            </div>
          </div>
          
          <div className="Template-fill-in-header-main-container">
            <div className="compliance-tracker-consultant-fill-in-header-main-container">
              <div className="Template-fill-in-header-text-main-container">

                <div>
                  <h3>Compliance Tracker - <span className="secondary-color-paragraph"> View Consultant Submissions </span> </h3>
                  <p>View completed template submissions that have been submitted by Consulatant.</p>
                </div>

                <div>
                  <h2>SHE File: <span style={{ color: 'black' }}>{selectedSheFileName} </span></h2>
                </div>
              </div>
                
              <div>
                <div>
                  <p>Company <span className="secondary-color-paragraph">{selectedCompanyName} </span> , Department <span className="secondary-color-paragraph">{selectedDepartmentName}</span></p>
                </div>
                <h2>
                  <span className="secondary-color-paragraph">
                    SHE File Score : {selectedSheFileUserScore || 0} /{selectedSheFileScore}
                  </span>
                </h2>
              </div>
            </div>

            <div className='complaince-tracker-employees-medical-upload-main-text-details-section-a-container'>
              <div>
                <h3>Section A - <span className="secondary-color-paragraph">Templates</span> </h3>
                
              </div>
            </div>

            {/* Section A - Templates  */}
            {isLoading ? (
              <div className="loading-spinner-container">
                <LiaSpinnerSolid className="lia-spin-solid-icon" />
              </div>
            ) : (
              <div className='compliance-tracker-consultant-fill-in-table-main-container'>
                <div className="compliance-tracker-consultant-fill-in-table-container">
                  <table className="compliance-tracker-consultant-fill-in-table">
                    <colgroup>
                      <col style={{width: "100px"}}/>{/*Column -  View */}
                      <col style={{width: "150px"}}/>{/*Column -  Submission Status */}
                      <col style={{width: "250px"}}/>{/*Column -  Template Name */}
                      <col style={{width: "250px"}}/>{/*Column -  Template Reference */}
                      <col style={{width: "100px"}}/>{/*Column -  User Score */}
                      <col style={{width: "100px"}}/>{/*Column -  Template Score */}
                      <col style={{width: "100px"}}/>{/*Column -  Percentage */}
                      <col style={{width: "150px"}}/>{/*Column -  Template Frequency */}
                      <col style={{width: "150px"}}/>{/*Column -  Template Frequency */}
                      <col style={{width: "150px"}}/>{/*Column -  QA Status */}
                      <col style={{width: "200px"}}/>{/*Column -  QA Status Comment */}
                    </colgroup>
                    
                    <thead>
                      <tr>
                        <th>View</th>
                        <th>Status</th>
                       
                        <th>Template Name</th>
                        <th>Template Reference</th>
                        <th>User Score</th>
                        <th>Template Score</th>
                        <th>Percentage</th>
                        <th>File Frequency</th>
                        <th>File Expiry Date</th>
                        <th>Validity</th>
                        <th>QA Status</th>
                        <th>QA Status Comment</th>
                      </tr>
                    </thead>

                    <tbody>
                      {regularTemplates.length === 0 ? (
                        <tr>
                          <td colSpan="10" className="no-data-message">
                            <i>Ooops! They may be a problem , no templates found.</i>
                          </td>
                        </tr>
                      ) : (
                        regularTemplates.map((document, index) => (
                          <tr key={index}>

                            {/* Column - View  */}
                            <td>
                              

                              {document.template_submission_status === 'Saved' || document.template_submission_status === 'Completed' ? (
                                <FaRegFolder 
                                  className='template-save-icon'
                                  onClick={() => handleViewTemplateDocument(document.template_id)} 
                                  style={{ cursor: 'pointer' }}
                                />
                              )  : 
                                <i>No Document Uploaded</i>
                              }
                            </td>

                            {/* Column - Status */}
                            <td>
                              {document.template_submission_status === 'Saved' ? (
                                <div className="saved-status">
                                  <IoIosCloudDone /> {document.template_submission_status}
                                </div>
                                ) : document.template_submission_status === 'Not Started' ? (
                                  <div className="not-saved-status">
                                    <MdCancel /> {document.template_submission_status}
                                  </div>
                                ) : document.template_submission_status === 'Completed' ? (

                                  <div className="completed-status">
                                    <AiOutlineFileDone /> {document.template_submission_status}
                                  </div>
                                  
                                ) : null
                              }
                            </td>

                            
                            
                            <td>{document.template_name}</td>
                            <td>{document.template_reference}</td>
                            <td>{document.user_template_score}</td>
                            <td>{document.template_score}</td>
                            <td>{document.user_template_percentage} %</td>
                            <td>{document.template_frequency}</td>
                            <td>{document.period_expiry_date}</td>
                            <td> <p>Not Valid</p></td>
                            <td>{document.qa_status }</td>
                            <td>{document.qa_comment || "No comment"}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Section B - Manual Uploads */}
            {manualTemplates.length > 0 && (
              <div className="manual-templates-section">
                {manualTemplates.map((document, templateIndex) => (
                  <div key={templateIndex} className='complaince-tracker-employees-medical-upload-main-table-container'>
                    <div className='complaince-tracker-employees-medical-upload-main-text-container'>
                      <div className='complaince-tracker-employees-medical-upload-main-text-details-container'>
                        <div>
                          <h3>Section B - <span className="secondary-color-paragraph">Employee Medicals</span></h3>
                          <p>This section is the template that are all the employees that require medicals at {selectedCompanyName} and site {selectedDepartmentName} . </p>
                          <b>Template Details</b>
                          <p>Template Name : <span className="secondary-color-paragraph">{document.template_name}</span></p>
                          <p>Template Reference : <span className="secondary-color-paragraph">{document.template_reference}</span> </p>
                        </div>
                      </div>

                      <div className='complaince-tracker-employees-medical-upload-main-text-score-container'>
                        <div className='complaince-tracker-employees-medical-upload-main-text-score-container-container'>
                          <div>
                            <div>
                              <h3>Template Score</h3>
                            </div>
                            <div>
                              <p><span className="secondary-color-paragraph">{document.user_template_score || 0} / {document.template_score}</span></p>
                            </div>
                            <div>
                              <p><span className="secondary-color-paragraph">{document.user_template_percentage || 0} % </span></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Employee Table */}
                    <div>
                      <h3>Employee Submissions for <span className="secondary-color-paragraph">{document.template_name}</span></h3>
                      
                      <div className="manual-upload-employees-table-container">
                        {loadingEmployees ? (
                          <div className="loading-spinner-container">
                            <LiaSpinnerSolid className="lia-spin-solid-icon" />
                          </div>
                        ) : (
                          <table className="compliance-tracker-consultant-fill-in-table">
                            <colgroup>
                              <col style={{ width: "50px" }} />
                              <col style={{ width: "150px" }} />
                              <col style={{ width: "100px" }} />
                              <col style={{ width: "250px" }} />
                              <col style={{ width: "100px" }} />
                              <col style={{ width: "100px" }} />
                              <col style={{ width: "100px" }} />
                              <col style={{ width: "150px" }} />
                              <col style={{ width: "150px" }} />
                              <col style={{ width: "150px" }} />
                              <col style={{ width: "150px" }} />
                              <col style={{ width: "150px" }} />
                            </colgroup>

                            <thead>
                              <tr>
                                <th>View</th>
                                <th>Status</th>
                               
                                <th>Employee ID</th>
                                <th>Employee Name</th>
                                <th>User Score</th>
                                <th>Template Score</th>
                                <th>Percentage</th>
                                <th>Upload Frequency</th>
                                <th>File Expiry Date</th>
                                <th>Validity</th>
                                <th>QA Status</th>
                                <th>QA Comment</th>
                              </tr>
                            </thead>

                            <tbody>
                              {(!employees[document.template_id] || employees[document.template_id].length === 0) ? (
                                <tr>
                                  <td colSpan="9" className="no-data-message">
                                    <i>No employees found for company {selectedCompanyName} and site {selectedDepartmentName}.</i>
                                  </td>
                                </tr>
                              ) : (
                                employees[document.template_id].map((employee, idx) => (
                                  <tr key={idx}>
                                    <td>

                                      {employee.emp_response_status === 'Saved' || employee.emp_response_status === 'Completed'? (
                                        <FaRegFolder 
                                          className='template-save-icon'
                                          onClick={() => handleViewEmployeeDocument(employee, document.template_id)}
                                          style={{ cursor: 'pointer' }}
                                        />
                                          )  : 
                                            <i>No File</i>
                                        }
                                     
                                    </td>

                                    
                                    {/* Column - Employee Status*/}
                                    <td>
                                      {employee.emp_response_status === 'Saved' ? (
                                        <div className="saved-status">
                                          <IoIosCloudDone /> {employee.emp_response_status}
                                        </div>
                                      ) : employee.emp_response_status === 'Not Started' ? (
                                        <div className="not-saved-status">
                                          <MdCancel /> {employee.emp_response_status}
                                        </div>
                                      ) : employee.emp_response_status === 'Completed' ? (
                                        <div className="completed-status">
                                          <AiOutlineFileDone /> {employee.emp_response_status}
                                        </div>
                                      ): null}
                                    </td>

                                    


                                    <td>{employee.employee_id}</td>
                                    <td>{`${employee.employee_name} ${employee.employee_surname}`}</td>
                                    <td>{employee.emp_template_user_score}</td>
                                    <td>{employee.emp_template_score}</td>
                                    <td>{`${employee.emp_template_user_percentage || 0} %`}</td>
                                    <td>{employee.emp_file_upload_intervals}</td>
                                    <td>{employee.emp_file_expiry_date}</td>
                                    <td><p>Valid</p></td>
                                    <td>{employee.emp_qa_status || 'Not Started'}</td>
                                    <td>{employee.emp_qa_comment || 'Not Started'}</td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Template Document Viewer Modal */}
      {viewingTemplateDocument && (
        <div 
          className="full-screen-image-overlay" 
          onClick={closeTemplateDocumentViewer}
        >
          <div className="full-screen-document-container">
            <h3>SHE File Document: {viewingTemplateDocument.file_name || 'Document'}</h3>
            {loadingTemplateDocument ? (
              <div className="loading-spinner-container">
                <LiaSpinnerSolid className="lia-spin-solid-icon" />
              </div>
            ) : (
              renderTemplateDocument(viewingTemplateDocument)
            )}

            <div className="document-details">
              <h3>Document Details</h3>
              <p><strong>File Name:</strong> {viewingTemplateDocument.file_name || 'N/A'}</p>
              <p><strong>Expiry Date:</strong> {viewingTemplateDocument.file_expiry_date || 'N/A'}</p>
              <p><strong>QA Status:</strong> {viewingTemplateDocument.qa_status || 'Not Started'}</p>
              <p><strong>QA Comment:</strong> {viewingTemplateDocument.qa_comment || 'No comments'}</p>
              <p><strong>Submitted By:</strong> {`${viewingTemplateDocument.filled_in_by_user_name || ''} ${viewingTemplateDocument.filled_in_by_user_surname || ''}`}</p>
              <p><strong>Date Submitted:</strong> {new Date(viewingTemplateDocument.date_submitted).toLocaleString()}</p>
            </div>
            
            <button 
              className="close-image-modal-btn" 
              onClick={closeTemplateDocumentViewer}
            >
              &times;
            </button>
          </div>
        </div>
      )}

      {/* Employee Document Viewer Modal */}
      {viewingEmployeeDocument && (
        <div 
          className="full-screen-image-overlay" 
          onClick={closeEmployeeDocumentViewer}
        >
          <div className="full-screen-document-container">
            <h3>Employee Document: {viewingEmployeeDocument.file_name || 'Document'}</h3>
            {loadingEmployeeDocument ? (
              <div className="loading-spinner-container">
                <LiaSpinnerSolid className="lia-spin-solid-icon" />
              </div>
            ) : (
              renderEmployeeDocument(viewingEmployeeDocument)
            )}

            <div className="document-details">
              <h3>Image Upload Details </h3>
              <p><strong>File Name:</strong> {viewingEmployeeDocument.file_name || 'N/A'}</p>
              <p><strong>Expiry Date:</strong> {viewingEmployeeDocument.file_expiry_date || 'N/A'}</p>
              <p><strong>QA Status:</strong> {viewingEmployeeDocument.qa_status || 'Not Started'}</p>
              <p><strong>QA Comment:</strong> {viewingEmployeeDocument.qa_comment || 'No comments'}</p>
              <p><strong>Submitted By:</strong> {`${viewingEmployeeDocument.filled_in_by_user_name || ''} ${viewingEmployeeDocument.filled_in_by_user_surname || ''}`}</p>
              <p><strong>Date Submitted:</strong> {new Date(viewingEmployeeDocument.date_submitted).toLocaleString()}</p>
            </div>
            
            <button 
              className="close-image-modal-btn" 
              onClick={closeEmployeeDocumentViewer}
            >
              &times;
            </button>
          </div>
        </div>
      )}

      {/* Full Screen Image Modal */}
      {fullScreenImage && (
        <div 
          className="full-screen-image-overlay" 
          onClick={closeFullScreenImage}
        >
          <div className="full-screen-image-container">
            <img 
              src={fullScreenImage} 
              alt="Full Screen Preview" 
              className="full-screen-image"
              onClick={(e) => e.stopPropagation()} 
            />
            <button 
              className="close-image-modal-btn" 
              onClick={closeFullScreenImage}
            >
              &times;
            </button>
          </div>
        </div>
      )}

  
    </div>
  );
};

export default ToasterViewTemplateComplianceSubmissions;